import './MatchStatisticsScrollable.less';

import React from 'react';
import clsx from 'clsx';
import useWindowSize from '../../../hooks/useWindowSize';
import { isMobileChannel } from '../../../common/util';

function MatchStatisticsScrollable({
    children,
    className = ''
}: {
    children: React.ReactNode | React.ReactNode[];
    className?: string;
}) {
    const windowSize = useWindowSize();
    const isScrollable = !isMobileChannel() && windowSize?.height > 700;
    return (
        <div
            className={clsx('infocentre-mt-statistics-scrollable  pb-20', className, { 'overflow-auto': isScrollable })}
        >
            {children}
        </div>
    );
}

export default MatchStatisticsScrollable;
